
export const convertFormat = (data) => {
  const convertedData = {};
  for (let q_id in data.answers) {
    let q_data = data.answers[q_id];
    let value = Array.isArray(q_data.value) ? q_data.value[0] : q_data.value;
    convertedData[q_id] = value;
  }
  return convertedData;
};


export const prepareWebhookData = (convertedData) => {
  let data = {
    name: null,
    phone: null,
    other_fields: {}
  };

  // Assuming that the 'name' and 'phone' fields are identifiable by specific question ids
  // For example, let's say 'q1' corresponds to 'name' and 'q2' corresponds to 'phone'
  for (let key in convertedData) {
    switch(key) {
      case 'name': // Assuming 'q1' is the identifier for 'name'
        data.name = convertedData[key];
        break;
      case 'phone': // Assuming 'q2' is the identifier for 'phone'
        data.phone = convertedData[key];
        break;
      default:
        // All other fields are grouped under 'other_fields'
        data.other_fields[key] = convertedData[key];
    }
  }

  return data;
};

// Prepare data for Google Apps Script webhook (flat JSON, no nesting)
export const prepareGoogleSheetData = (convertedData) => {
  // Ensure everything is top-level
  return convertedData;
};

// Posts data to Google Apps Script endpoint
export const submitGoogleAppsScriptWebhook = (data, config) => {
  const {
    mode = 'prod',
    mockSuccess = true,
    url = "https://script.google.com/macros/s/AKfycby_FQ29DAItpbgOYy7mstBS6SkihSrwls6hFkohPsaaw9OakbVvtzIU4v2wzVsR6AJQ/exec"
  } = config || {};

  return new Promise((resolve, reject) => {
    if (mode === 'dev') {
      setTimeout(() => {
        if (mockSuccess) {
          resolve('Success');
        } else {
          reject(new Error('Failed to submit the form in development mode.'));
        }
      }, 500);
    } else {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if (response.ok) {
          resolve('Success');
        } else {
          reject(new Error('Failed to submit to Google Apps Script.'));
        }
      })
      .catch(() => {
        reject(new Error('Failed to submit to Google Apps Script due to network or server issue.'));
      });
    }
  });
};

export const submitPrivrWebhook = (data, config) => {
  return new Promise((resolve, reject) => {
    if (config.mode === 'dev') {
      // Simulate an API call with a delay
      setTimeout(() => {
        if (config.mockSuccess) {
          resolve('Success');
        } else {
          reject(new Error('Failed to submit the form in development mode.'));
        }
      }, 1000); // simulate a delay as if an API call was made
    } else {
      // Send data using Fetch API
      fetch("https://www.privyr.com/api/v1/incoming-leads/0vZfjMQw/Tk4OqHzs#generic-webhook", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if (response.ok) {
          resolve('Success');
        } else {
          reject(new Error('Failed to submit the form.'));
        }
      })
      .catch(error => {
        reject(new Error('Failed to submit the form due to network or server issue.'));
      });
    }
  })
};

// Generic lead submission orchestrator
// options: { mode: 'dev'|'prod', targets: 'privyr'|'google'|'both', successPolicy: 'any'|'all', mockSuccess?: boolean, googleUrl?: string }
export const submitLeads = (convertedData, options = {}) => {
  const {
    mode = (typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost') ? 'dev' : 'prod',
    targets = 'both',
    successPolicy = 'any',
    mockSuccess = true,
    googleUrl
  } = options;

  const wantsPrivyr = targets === 'privyr' || targets === 'both';
  const wantsGoogle = targets === 'google' || targets === 'both';

  const tasks = [];
  const result = {};

  if (wantsPrivyr) {
    const privrPayload = prepareWebhookData(convertedData);
    const p = submitPrivrWebhook(privrPayload, { mode, mockSuccess })
      .then((res) => { result.privyr = { ok: true }; return res; })
      .catch((err) => { result.privyr = { ok: false, error: err }; throw err; });
    tasks.push(p);
  }

  if (wantsGoogle) {
    const googlePayload = prepareGoogleSheetData(convertedData);
    const p = submitGoogleAppsScriptWebhook(googlePayload, { mode, mockSuccess, url: googleUrl })
      .then((res) => { result.google = { ok: true }; return res; })
      .catch((err) => { result.google = { ok: false, error: err }; throw err; });
    tasks.push(p);
  }

  if (tasks.length === 0) {
    return Promise.resolve({});
  }

  if (successPolicy === 'all') {
    return Promise.allSettled(tasks).then((settled) => {
      const allOk = settled.every(s => s.status === 'fulfilled');
      if (allOk) return result;
      const aggregateError = new Error('One or more lead submissions failed.');
      aggregateError.result = result;
      throw aggregateError;
    });
  } else {
    // any
    return Promise.any(tasks).then(() => result).catch((err) => {
      // If all failed, include result details
      const aggregateError = new Error('All lead submissions failed.');
      aggregateError.result = result;
      throw aggregateError;
    });
  }
};

